import { GenerateImageTag } from '../helpers/helpers';

export default (item, html) => (
    html`
        <a class="search-result default-page" href="${item.url}" x-data="{ priceGBP: '£${ item.priceGBP }', priceEUR: '€${ item.priceEUR }' }">
            <div class="search-result__imageContainer">
                ${ !item.image || item.image === '' ? html`
                <div class="search-result__image-fallback">
                    <div class="search-result__image-fallback__accent" aria-hidden="true"></div>
                    ${ item.category ? html`
                        <span class="search-result__image-fallback__text">${ item.category.replace('General','') }</span>
                    ` : 'Pages'}
                    <div class="search-result__image-fallback__icon" aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" width="84" height="84" viewBox="0 0 84 84" fill="none">
                            <mask id="mask0_2078_3140" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="84" height="84">
                                <rect width="83.5" height="83.5" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_2078_3140)">
                                <path d="M37.7925 71.236C36.6618 70.2502 35.9514 69.0035 35.6615 67.4958H47.8386C47.5486 69.0035 46.8383 70.2502 45.7076 71.236C44.5769 72.2217 43.2577 72.7146 41.75 72.7146C40.2424 72.7146 38.9232 72.2217 37.7925 71.236ZM30.0948 60.5375V58.1021H53.4052V60.5375H30.0948ZM30.0948 51.1438C27.0216 49.0563 24.6006 46.4614 22.8321 43.3591C21.0635 40.2569 20.1792 36.8212 20.1792 33.0521C20.1792 27.0215 22.2667 21.9188 26.4417 17.7438C30.6167 13.5688 35.7195 11.4813 41.75 11.4813C47.7806 11.4813 52.8834 13.5688 57.0584 17.7438C61.2334 21.9188 63.3209 27.0215 63.3209 33.0521C63.3209 36.8212 62.4366 40.2569 60.668 43.3591C58.8994 46.4614 56.4785 49.0563 53.4052 51.1438H30.0948ZM30.7907 48.7083H52.7094C55.3188 46.8528 57.3338 44.5623 58.7545 41.837C60.1751 39.1116 60.8854 36.1833 60.8854 33.0521C60.8854 27.7174 59.0299 23.1945 55.3188 19.4833C51.6077 15.7722 47.0848 13.9167 41.75 13.9167C36.4153 13.9167 31.8924 15.7722 28.1813 19.4833C24.4702 23.1945 22.6146 27.7174 22.6146 33.0521C22.6146 36.1833 23.3249 39.1116 24.7456 41.837C26.1663 44.5623 28.1813 46.8528 30.7907 48.7083Z" fill="currentColor"/>
                            </g>
                        </svg>
                    </div>
                </div>    
            ` : html`
                <div class="search-result__imageContainer">
                    ${ GenerateImageTag(item, html) }
                </div>
            ` }
            </div>
            <div class="search-result__textContainer">
                ${ item.category ? html`
                <span class="search-result__category">
                    ${ item.category.replace('General','') }
                </span>
            ` : ''}
                <h2 class="search-result__heading">${item.title}</h2>
            </div>
        </a>
    `
);